import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=9882d96e&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"
import style0 from "./Contact.vue?vue&type=style&index=0&id=9882d96e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9882d96e",
  null
  
)

export default component.exports